import { useEffect, useState } from "react";
import LoginIntro from "../../../components/common/LoginIntro";
import { ROUTES } from "../../../routes";
import { useNavigate } from "react-router-dom";
import useAuthUser from "../../../hooks/use-auth-user";
import useSessionConfig from "../../../hooks/use-session-config";
import { Generics } from "../../../utils/generics";
import ROLE from "../../../modules/role";
import AppUser from "../../../modules/app-user/app-user";

type TPageSelectRole = {
  title: string;
  url: string;
  value: string;
};

export default function PageAuth() {
  const navigate = useNavigate();
  const { user, isLoading } = useAuthUser();
  const sessConfig = useSessionConfig();

  const [roles, setRoles] = useState<TPageSelectRole[]>([
    {
      title: "System Administrator",
      url: ROUTES.PORTAL_DASHBOARD,
      value: ROLE.ADMIN,
    },
    {
      title: "Programme Administrator",
      url: ROUTES.PORTAL_DASHBOARD,
      value: ROLE.PROGRAMME_ADMIN,
    },
    {
      title: "SIT Supervisor",
      url: ROUTES.PORTAL_DASHBOARD,
      value: ROLE.SUPERVISOR,
    },
    {
      title: "Industry Supervisor",
      url: ROUTES.PORTAL_DASHBOARD,
      value: ROLE.INDUSTRY_SUPERVISOR,
    },
    { title: "Student", url: ROUTES.PORTAL_DASHBOARD, value: ROLE.STUDENT },
  ]);

  useEffect(() => {
    if (!isLoading && !user.logged) {
      sessConfig.set("redirect", Generics.getUrlPathAndParams());
      navigate("/auth/login", { replace: true });
    }
  }, [isLoading, user]);

  const onSelectRole = async (selectedRole: TPageSelectRole) => {
    await AppUser.setInfo({ role: selectedRole.value });
    navigate(selectedRole.url);
  };

  return (
    <div className="PageAuth" data-comp="PageAuth">
      <div className="PA__row">
        <div className="PA__col PA__col--desc">
          <div className="PA__col--desc-inner">
            <LoginIntro />
          </div>
        </div>
        <div className="PA__col PA__col--main">
          <div
            className="d-flex flex-column justify-content-center align-items-stretch gap-3"
            style={{ minWidth: "140px" }}
          >
            <h1
              className="text-light text-center"
              style={{ fontSize: "22px", fontWeight: "400" }}
            >
              Please click on the role
              <br />
              you would like to access...
            </h1>
            <div className="role-selection d-flex flex-column justify-content-center align-items-stretch gap-3">
              {roles
                .filter((role) => {
                  return user.roles.includes(role.value);
                })
                .map((role, index) => (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => onSelectRole(role)}
                    key={index}
                  >
                    {role.title}
                  </button>
                ))}
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => navigate(ROUTES.AUTH_LOGOUT)}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
